import { create } from 'zustand';

interface MessageDetailDialogState {
    isOpen: boolean;
    title: string;
    message: string;
    details: string;
    actions: {
        open: () => void;
        close: () => void;
        setTitle: (title: string) => void;
        setMessage: (message: string) => void;
        setDetails: (details: string) => void;
        clear: () => void;
    };
}

export const useMessageDetailDialogStore = create<MessageDetailDialogState>()((set) => ({
    isOpen: false,
    title: '',
    message: '',
    details: '',
    actions: {
        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
        setTitle: (title) => set({ title }),
        setMessage: (message) => set({ message }),
        setDetails: (details) => set({ details }),
        clear: () => set({ title: '', message: '', details: '' }),
    },
}));
